// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1aX73","gfeWrapper":"CalendarEvent_gfeWrapper__1jHKo"};